export default __webpack_public_path__ + "static/media/phone-icon.74b43570.svg";